import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  place-items: center;
  width: 100%;
  background-color: #b3683b;
  border-top: 3px solid #65381e;
  padding: 0.375rem 0;
  z-index: 100;
`;

export const Placeholder = styled.div`
    height: 63px;
    margin-top: 0.125rem;
`

export const Item = styled.div`
  font-weight: 700;
  text-align: center;
  cursor: pointer;
  font-size: 1em;

  img {
    max-width: 1.5rem;
  }
`;
